import { render, staticRenderFns } from "./ItemStatement.vue?vue&type=template&id=195129ce&"
import script from "./ItemStatement.vue?vue&type=script&lang=js&"
export * from "./ItemStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports